import CalistaPartyConfigRoute from './CalistaPartyConfigRoute'

const routes = [
    new CalistaPartyConfigRoute()
]

export default routes
